/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Toast_Reject_PxkInputs */

const vi_aml_toast_reject_pxk = /** @type {(inputs: Aml_Toast_Reject_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã từ chối phiếu xuất kho`)
};

/**

* @param {Aml_Toast_Reject_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_toast_reject_pxk = /** @type {((inputs?: Aml_Toast_Reject_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Toast_Reject_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_toast_reject_pxk(inputs)
});